import React from 'react'
import PropTypes from 'prop-types'
import './styles.scss'

const SpinningButton = ({ src, className, link, ...otherProps }) => {
  return link ? (
    <a className={`${className} spinning-button`} {...otherProps}>
      <img src={src} />
    </a>
  ) : (
    <button className={`${className} spinning-button`} {...otherProps}>
      <img src={src} />
    </button>
  )
}

SpinningButton.propTypes = {
  link: PropTypes.bool,
  className: PropTypes.string,
  src: PropTypes.any
}

export default SpinningButton
